import type { SqlImport } from '@/services/db/sql-import/entity';
import { importTypeOf } from './rows';

/** The saved import's fields as `ImportSummary` reads them: the wire's nullable ids as absent. */
export function summaryInput(sqlImport: SqlImport) {
  return {
    import_type: importTypeOf(sqlImport.import_type),
    id_field_name: sqlImport.id_field_name,
    segment_id: sqlImport.segment_id ?? undefined,
    segment_name: sqlImport.segment_name ?? undefined,
    clear_empty_cells: sqlImport.clear_empty_cells,
    ignore_suppress_err: sqlImport.ignore_suppress_err,
  };
}
